<template>
    <ValidationObserver ref="observer" v-slot="{ invalid }">
        <v-form @submit.prevent="onSubmit">
            <v-row>
                <v-col cols="12" md="12">
                    <ValidationProvider rules="required" v-slot="v">
                        <v-autocomplete dense v-model="selectedItem" deletable-chips chips label="Tipo de aportes"
                            :error-messages="v.errors[0]" :items="selectorDetalleAp" clearable hide-selected
                            item-value="tipapo" :item-text="item => `${item.codapo} - ${(item.destipapo)}`"
                            color="primary"></v-autocomplete>
                    </ValidationProvider>
                </v-col>
                <v-col cols="12" md="12" class="d-flex justify-end">
                    <v-btn @click="onSubmit" elevation="0" class="pa-5" :disabled="invalid" color="primary">
                        <v-icon class="mr-3">fa-file-pdf</v-icon>
                        Imprimir Boletas
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </ValidationObserver>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import { ValidationProvider, ValidationObserver } from 'vee-validate';

export default {
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            valores: [],
            selectedItem: [],
            imprimir: {
                //url: '',
                //EN USOFo
                descargarPdf: 0,
                tipo_aporte: '',
                tipo_frm: 1,
                nro_afi_listado: '',
                token: this.token,

                //REVISAR
                nro_afi_add: '',
                nro_afi_desde: '',
                nro_afiliado: '',
                tpapo: '',
                nroafilia: '',
                autos: '',
                tipo_pericia: 1,
                totregulado: '',
                fpago: '',
                reimpresion: 0,

            },

        }
    },
    mounted() {
        this.getResumenAportes()
    },
    methods: {
        ...mapActions('boletas', ['imprimirPdf', 'getResumenAportes']),

        onSubmit() {
            this.$refs.observer.validate().then(result => {
                if (result) {

                    const data = {
                        url: process.env.VUE_APP_APORTES,
                        nroafi: this.nroafi,
                        tapid: this.selectedItem,
                        da: '',
                        token: this.token
                    }
                    this.imprimirPdf(data)
                } else {
                    this.showSnack({
                        message: 'Formulario inválido, no se puede enviar la petición',
                        type: '400'
                    })
                }
            });
        },


        imprimirBoletas() {
            const objetosAgrupadosPorTipo = {};
            this.imprimir.token = this.token
            for (const objeto of this.selectedItem) {
                const tipo = objeto.tipapo;
                // Si el tipo no existe en el objeto agrupado, crear un arreglo
                if (!objetosAgrupadosPorTipo[tipo]) {
                    objetosAgrupadosPorTipo[tipo] = [];
                }
                // Agregar el objeto al arreglo correspondiente en el objeto agrupado
                objetosAgrupadosPorTipo[tipo].push(objeto);
            }
            for (const [key, value] of Object.entries(objetosAgrupadosPorTipo)) {
                let listado = ''
                value.forEach(e => {
                    listado = listado + e.mes_cuota.toString() + '/' + e.anio_convenio.toString() + '-'
                    let a = this.nroafi + '|' + listado.slice(0, listado.length - 1)
                    this.imprimir.nro_afi_listado = a.toString()
                    this.imprimir.tpapo = e.tipapo
                    this.imprimir.tipo_aporte = e.tipapo
                });
                this.imprimir.url = VUE_APP_BOLETAS

                //this.imprimir.url = 'http://boletas.cajapsipba.org.ar/boletaa4-2023.php'
                console.log(this.imprimir)
                this.imprimirPdf(this.imprimir)
                this.imprimir.nro_afi_listado = ''
                this.listado = ''
                this.imprimir.tipo_aporte = ''
                this.imprimir.tipapo = ''
            }

        },
        changedBoletas(value) {
            console.log(value)
        }
    },
    computed: {
        ...mapGetters('boletas', ['tpapo', 'mescuota', 'boletasDisponibles', 'porTipApo', 'conceptosDeuda', 'resumenAportes', 'selectorDetalleAp']),
        ...mapGetters('auth', ['nroafi', 'token'])
    },
    props: ['boletas']
};
</script>